import React, { useState } from "react";
import { ReactComponent as AddCamera } from "assets/img/icons/camera.svg";
import { ReactComponent as DeleteIcon } from "assets/img/icons/Delete.svg";
import { ReactComponent as Edit } from "assets/img/icons/Edit.svg";
import ImageSelectAndCrop from "components/ImageSelectAndCrop";
import MediaPreview from "components/MediaPreview/MediaPreview";
import LazyLoadImage from "components/LazyLoadImage";

const styles = {
  imageContainer: {
    borderRadius: "10px",
    margin: "10px 0",
    height: "350px",
    width: "370px",
    background: "#ccc",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  addIcon: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
  },
  image: {
    objectFit: "cover",
  },
  editOptions: {
    position: "absolute",
    top: 0,
    right: "35px",
    background: "#000a",
    padding: "5px",
    color: "white",
    height: "25px",
    width: "25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRight: "1px solid #ccc",
    zIndex: 2,
  },
  deleteOptions: {
    position: "absolute",
    top: 0,
    right: "10px",
    background: "#000a",
    padding: "5px",
    color: "white",
    height: "25px",
    width: "25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2,
  },
  iconsWidth: {
    width: "24px",
    height: "24px",
    fill: "white",
    cursor: "pointer",
  },
};

export default ({
  src,
  height = "350px",
  width = "370px",
  onUpdate,
  isOwner,
  isUploading,
}) => {
  const classes = styles;
  const [randomNumber] = useState(Math.round(Math.random() * 10000));

  return (
    <div style={classes.imageContainer} className="col-xl-12">
      {isUploading && (
        <div
          className={"isUploadingContainer"}
          style={{
            width,
            height,
          }}
        >
          <span>Updating Image...</span>
        </div>
      )}
      {!src && isOwner && (
        <ImageSelectAndCrop
          id={`fun-image-file-${randomNumber}`}
          aspect={4 / 4}
          onUpdate={onUpdate}
        >
          <AddCamera style={classes.addIcon} />
        </ImageSelectAndCrop>
      )}
      {src && (
        <>
          {isOwner && (
            <>
              <div
                title="Clear Image"
                style={classes.deleteOptions}
                onClick={() => {
                  onUpdate("");
                }}
              >
                <DeleteIcon style={classes.iconsWidth} />
              </div>
              <ImageSelectAndCrop
                id={`fun-image-file-${randomNumber}`}
                aspect={4 / 4}
                onUpdate={onUpdate}
              >
                <div style={classes.editOptions} title="Update Image">
                  <Edit style={classes.iconsWidth} />
                </div>
              </ImageSelectAndCrop>
            </>
          )}
          <MediaPreview attachment={src} type={"image"} teamPage={false}>
            <LazyLoadImage
              image={src}
              key={src}
              alt={src}
              style={{
                borderRadius: "10px",
                height,
                width,
                objectFit: classes.image,
              }}
            />
          </MediaPreview>
        </>
      )}
    </div>
  );
};
